/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { getToken } from './api';

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1';

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${getToken()}` }
});

export const menuApi = {
  getCurrentMenu: () =>
    axios.get(`${API_BASE}/menu/current`, authHeaders()),

  getNextMenu: () =>
    axios.get(`${API_BASE}/menu/next`, authHeaders()),

  getSlotOptions: (date: string, slot: string) =>
    axios.get(`${API_BASE}/menu/${date}/${slot}/options`, authHeaders()),

  getRecommended: (date: string, slot: string) =>
    axios.get(`${API_BASE}/menu/recommended/${date}/${slot}`, authHeaders()),

  getPortionPreview: (menuItemId: number) =>
    axios.get(`${API_BASE}/menu/selections/portion-preview?menu_item_id=${menuItemId}`, authHeaders()),

  createSelection: (data: {
    menu_item_id: number;
    auto_portion?: boolean;
    portion_multiplier?: number;
    special_instructions?: string;
    customizations?: any[];
  }) =>
    axios.post(`${API_BASE}/menu/selections`, data, authHeaders()),

  updateSelection: (id: number, data: any) =>
    axios.put(`${API_BASE}/menu/selections/${id}`, data, authHeaders()),

  deleteSelection: (id: number) =>
    axios.delete(`${API_BASE}/menu/selections/${id}`, authHeaders()),

  getMySelections: (weekOffset?: number) =>
    axios.get(`${API_BASE}/menu/my-selections?week=${weekOffset && weekOffset > 0 ? 'next' : 'current'}`, authHeaders()),

  skipMeal: (data: { skip_date: string; slot?: string; reason?: string }) =>
    axios.post(`${API_BASE}/menu/skip`, data, authHeaders()),

  getSkips: () =>
    axios.get(`${API_BASE}/menu/skips`, authHeaders()),

  // Custom meal suggestions
  createSuggestion: (data: {
    suggested_date: string;
    slot: string;
    dish_name: string;
    calories: number;
    protein_g: number;
    notes?: string;
  }) =>
    axios.post(`${API_BASE}/menu/suggestions`, data, authHeaders()),

  getSuggestions: (startDate: string, endDate: string) =>
    axios.get(`${API_BASE}/menu/suggestions?start_date=${startDate}&end_date=${endDate}`, authHeaders()),

  deleteSuggestion: (id: number) =>
    axios.delete(`${API_BASE}/menu/suggestions/${id}`, authHeaders()),
};
